import RechargeLog from './rechargeLog'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...RechargeLog
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/recharge/index.js